import React, { useCallback } from "react";
import { useObservable } from "micro-observables";
import { useDispatch } from "react-redux";

import {
    activeDataSelector,
    currentBlockSelector,
    newDataSelector,
    setActiveDataSelector,
    setCurrentBlockSelector,
    setUrlList
} from "../../../services/stepThree";
import DataSelectorList from "../components/DataSelectorList";
import EditDataSelectorDialog from "../components/DataSelectorList/EditDataSelectorDialog";
import useEditDataSelectorDialog from "../components/DataSelectorList/hooks/useEditDataSelectorDialog";
import { openUserAction } from "../../../../../../../services/UserActionConfirm/actions";
import useNormalizerDialog from "../components/DataSelectorList/hooks/useNormalizerDialog";
import NormalizerDialog from "../components/DataSelectorList/NormalizerDialog";

const DataSelectors = () => {
    const dispatch = useDispatch();
    const blockSelector = useObservable(currentBlockSelector);
    const activeData = useObservable(activeDataSelector);
    const newData = useObservable(newDataSelector);
    const dataSelectors = blockSelector.data_selectors;

    const {
        isOpenDataSelectorDialog,
        initialValuesDataSelectorDialog,
        setInitialValuesDataSelector,
        handleEditSelector,
        handleEditDataSelectorDialogClose,
        handleDataSelectorSubmit
    } = useEditDataSelectorDialog();

    const {
        isOpenNormalizerDialog,
        initialValuesNormalizerDialog,
        handleNormalizerDialogClose,
        handleNormalizerDialogSubmit,
        handleOpenNormalizerDialog
    } = useNormalizerDialog({ initialValuesDataSelectorDialog, setInitialValuesDataSelector });

    const handleDeleteDataSelector = useCallback(
        (index) => {
            const newBlockSelector = { ...blockSelector };

            newBlockSelector.data_selectors = blockSelector.data_selectors.reduce(
                (acc, dataSelector, itemIndex) => {
                    if(itemIndex !== index) {
                        acc.push(dataSelector);
                    }

                    return acc;
                },
                []
            );

            setCurrentBlockSelector(newBlockSelector);
            setUrlList([]);
            setActiveDataSelector(null);
        },
        [ blockSelector ]
    );

    const handleDeleteClick = useCallback(
        (index) => {
            dispatch(openUserAction({
                actionType: "remove Data Selector",
                action: () => handleDeleteDataSelector(index)
            }));
        },
        [ dispatch, handleDeleteDataSelector ]
    );

    const handleViewSelector = useCallback(
        (item) => {
            if(!activeData) {
                setActiveDataSelector(item);
            } else {
                setActiveDataSelector(null);
                setUrlList([]);
            }
        },
        [ activeData ]
    );

    if(!dataSelectors || dataSelectors.length === 0) {
        return null;
    }

    return (
        <>
            <DataSelectorList
                activeData={activeData}
                newData={newData}
                dataSelectors={dataSelectors}
                onDeleteDataSelector={handleDeleteClick}
                onEditSelectors={handleEditSelector}
                onViewSelector={handleViewSelector}
            />

            {
                initialValuesDataSelectorDialog && (
                    <EditDataSelectorDialog
                        isOpen={isOpenDataSelectorDialog}
                        initialValues={initialValuesDataSelectorDialog}
                        setInitialValues={setInitialValuesDataSelector}
                        onClose={handleEditDataSelectorDialogClose}
                        onSubmit={handleDataSelectorSubmit}
                        onOpenNormalizerDialog={handleOpenNormalizerDialog}
                    />
                )
            }

            {
                initialValuesNormalizerDialog && (
                    <NormalizerDialog
                        isOpen={isOpenNormalizerDialog}
                        initialValues={initialValuesNormalizerDialog}
                        onClose={handleNormalizerDialogClose}
                        onSubmit={handleNormalizerDialogSubmit}
                    />
                )
            }
        </>
    );
};

export default DataSelectors;
